import React from 'react';
import Modal from 'react-modal';
import { DOCUMENTS } from '../constants/config';
import { useI18n } from '../utilities/i18n';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: 0,
    transform: 'translate(-50%, -50%)',
    padding: '32px',
    borderRadius: '20px',
    maxWidth: 'min(600px, calc(100vw - 16px))',
    width: '90%',
    maxHeight: '80vh',
    overflow: 'hidden',
    background: 'linear-gradient(180deg, #0d1117 0%, #0b0f14 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
  },
  overlay: {
    backgroundColor: 'rgba(4, 7, 12, 0.92)',
    zIndex: 10000
  }
};

Modal.setAppElement('#root');

function DocumentsModal(props) {
  const { t } = useI18n();
  const items = [
    { key: 'docPrivacy', href: DOCUMENTS.privacy },
    { key: 'docTerms', href: DOCUMENTS.terms },
    { key: 'docPersonalData', href: DOCUMENTS.personalData },
    { key: 'docAgreement', href: DOCUMENTS.agreement },
    { key: 'docCookies', href: DOCUMENTS.cookies },
  ];

  return (
    <Modal
      isOpen={props.visible}
      onRequestClose={props.closeModal}
      style={customStyles}
    >
      <div className="documents-modal">
        <div className="documents-modal-header">
          <h2>{t('documents')}</h2>
          <button onClick={props.closeModal} className="documents-modal-close">×</button>
        </div>
        <div className="documents-modal-body">
          {items.map((item) => (
            <div className="document-item" key={item.key}>
              <h3>{t(item.key)}</h3>
              <a href={item.href} target="_blank" rel="noopener noreferrer" className="document-download-link">
                {t('downloadDocument')}
              </a>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}

export default DocumentsModal;
